import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setRoomCode } from '../../store/actions/login';
import { QuizStates, answerQuestion } from '../../store/actions/quiz';

import WaitingScreen from "./WaitingDevice/WaitingDevice"
import QuestionDevice from "./QuestionDevice/QuestionDevice"
import AnswerDevice from "./AnswerDevice/AnswerDevice"
import CommercialDevice from "./CommercialDevice/CommercialDevice"
import VoucherWinner from "./VoucherWinner/VoucherWinner"

import SocketAPI from "../../../services/socketAPI";
import Storage from "../../../services/storage";

export class Quiz extends Component {

    constructor(props) {
        super(props)
        // console.log('quiz constructor', SocketAPI.isRoomJoined, this.props.roomCode);

        // Reconnect support!
        if (!SocketAPI.isRoomJoined) {
            // const roomCode = Storage.getItem("PCSessionRoomCode");
            // const sessionId = Storage.getItem("PCSessionId")

            // console.log('Reconnect!', roomCode, sessionId);

            // SocketAPI.joinQuiz(roomCode, sessionId); 
            // this.props.setRoomCode(roomCode);
            // Disable automatic reconnect and go back to home
            this.goToHome();
        }


        this.questionAnswered = this.questionAnswered.bind(this);
		SocketAPI.addEndQuizHandler(() => {
			this.props.history.push('/result') 
        });
        
        const gameEndLoaded = localStorage.getItem("game_end_loaded")
		if (gameEndLoaded) {
			localStorage.removeItem("game_end_loaded")
			this.goToHome()	
		}
	}

	goToHome() {
		const urlParts = window.location.href.split("/");
		urlParts.splice(-1, 1);
		window.location.href = urlParts.join("/");
    }

    questionAnswered(e) {
        console.log("answerClicked:", e);
		console.log("Time:", new Date() - this.startTime);
		if (this.props.currentQuestion.answered) {
			// we have already collected an answer for this question, do nothing...
		} else {
			let question = this.props.currentQuestion;
            this.props.answerQuestion(question, e.id)        
            SocketAPI.answerQuestion(question, e.id, this.props.roomCode, Date.now() - this.props.startTime)
		}

    }


	render() {

        console.log('quiz state!')
        console.log('quizState=', this.props.currentQuizStep)
        let currentScreen;
        if (this.props.currentQuizStep === QuizStates.WAITING) {
            currentScreen = <WaitingScreen question={this.props.currentQuestion}/>


        }else if (this.props.currentQuizStep === QuizStates.QUESTION) {
            currentScreen = <QuestionDevice question={this.props.currentQuestion} onClick={this.questionAnswered} questionTimerFinished={this.props.questionTimerFinished} />
        }else if (this.props.currentQuizStep === QuizStates.ANSWER) {
            currentScreen = <AnswerDevice question={this.props.currentQuestion} result={this.props.currentResult }/>
        }else if (this.props.currentQuizStep === QuizStates.COMMERCIAL) {
            currentScreen = <CommercialDevice userName={this.props.userName} result={this.props.commercialResult}/>
        }else if (this.props.currentQuizStep === QuizStates.VOUCHER_WINNER) {
            currentScreen = <VoucherWinner userName={this.props.userName} result={this.props.voucherResult}/>
        }

        return(
            <div>
                { currentScreen }
            </div>
        )
	}
}
        
/**************************
 * Mapping REDUX global state to local props 
 **************************/

function mapStateToProps(state) {
    return {
        currentQuizStep: state.quiz.currentQuizStep,
        currentQuestion: state.quiz.currentQuestion,
        currentResult: state.quiz.currentResult,
        roomCode: state.login.roomCode.code,
        startTime: state.quiz.startTime,
        commercialResult: state.quiz.commercialResult,
        voucherResult: state.quiz.voucherResult,
        userName: state.login.userName,
        questionTimerFinished: state.quiz.questionTimerFinished
        // currentLoginStep: state.login.currentLoginStep,
        // avatarSelectionEnabled: state.login.avatarSelectionEnabled,
        // avatars: state.login.avatars,
        // roomCode: state.login.roomCode.code,
        // biosReset: state.login.roomCode.hasError
    }
}

function mapDispatchToProps(dispatch) {
    return {
        answerQuestion: bindActionCreators(answerQuestion, dispatch),
        // startQuiz: bindActionCreators(startQuiz, dispatch),
        setRoomCode: bindActionCreators(setRoomCode, dispatch)
        // setUserCode: bindActionCreators(setUserCode, dispatch),
        // startAvatarSelection: bindActionCreators(startAvatarSelection, dispatch),
        // resetBiosInput: bindActionCreators(resetBiosInput, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Quiz)


// WEBPACK FOOTER //
// ./src/components/pages/Quiz/Quiz.js